export default "__VITE_ASSET__4a13ad00__"